//import FindTextBookPopup from "@/pages/comp/book_order/textbook/popup/find_list";
import TextBookFindListArea from "@/pages/comp/book_order/textbook/common/find_list";

function FindTextBookPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    ...props
  };

  return (
    <div>
      <TextBookFindListArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        listOpt={myProps.listOpt}
      ></TextBookFindListArea>
    </div>
  );
};
export default FindTextBookPopup;